<template>
  <div class="content-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="内容标题" prop="title" style="width: 460px">
          <el-input v-model="form.title" placeholder="请输入内容标题" :disabled="disabledStatus" />
        </el-form-item>
        <el-form-item label="内容类别" prop="category" style="width: 460px">
          <el-select v-model="form.category" placeholder="请选择内容类别" :disabled="disabledStatus">
            <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容分类" prop="type" style="width: 460px">
          <el-select v-model="form.type" placeholder="请选择内容分类" :disabled="disabledStatus">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容简介" prop="introduction" style="width: 460px">
          <el-input v-model="form.introduction" type="textarea" :rows="4" />
        </el-form-item>
        <el-form-item label="编辑内容" prop="content" style="width: 824px;height: 590px;">
          <Toolbar style="border:1px solid #ccc;border-bottom: none;" :editor="editor" :default-config="toolbarConfig" :mode="mode" />
          <Editor v-model="form.content" class="editor-box" style="height: 500px; overflow-y: hidden; border: 1px solid rgb(204, 204, 204)" :default-config="editorConfig" :mode="mode" @onCreated="onCreated" @onBlur="onBlur" />
        </el-form-item>
      </div>
      <div class="white-container white-container-bottom marginTop">
        <el-form-item label="上传图片" prop="coverImage" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.homeListPicture" save-path="content/" title="首页列表图片" size-tips="335px*224px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.homeListPicture = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.marketListPagePicture" save-path="content/" title="列表页图片" size-tips="686px*260px" :limit-size="2" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.marketListPagePicture = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.myMarketListPictures" save-path="content/" title="我的资讯列表页图片" size-tips="162px*180px" :limit-size="2" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.myMarketListPictures = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.coverImage.shareCardImage" save-path="content/" title="小程序分享卡片" size-tips="500px*400px" :limit-size="2" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.shareCardImage = data)" />
          </div>
        </el-form-item>
        <el-form-item style="width: 100%; margin-left: -50px; padding-bottom: 30px;">
          <div class="flex btns">
            <el-button type="info" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
            <el-button style="background-color: #dc1000;border-color: #dc1000; color:#FFFFFF;" @click="preview">预览</el-button>
          </div>
        </el-form-item>

      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
    <el-dialog v-if="showPreviewDialog" :visible.sync="showPreviewDialog" title="市场内容预览" custom-class="preview-wrapper">
      <div class="qr-wrap">
        <img :src="urlCode" class="qr-code" style="width: 300px; height: 300px" alt="">
        <p>微信扫描二维码预览页面</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Content } from "@/model/Content";
import UploadImage from "@/components/UploadImage";
import Dialog from "@/components/Dialog";
import '@wangeditor/editor/dist/css/style.css';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { MyButtonMenu, BrMenu } from '../../../editor/customMenu.js';
import { Boot } from '@wangeditor/editor';
const w24 = {
  key: 'imageWidth24', // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new MyButtonMenu('24%'); // 把 `YourMenuClass` 替换为你菜单的 class
  },
};
const w48 = {
  key: 'imageWidth48', // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new MyButtonMenu(); // 把 `YourMenuClass` 替换为你菜单的 class
  },
};
const brMenu = {
  key: 'BrMenu',
  factory() {
    return new BrMenu();
  },
};

const module = { // JS 语法
  menus: [w24, w48],
  // 其他功能，下文讲解...
};

Boot.registerMenu(brMenu);
Boot.registerModule(module);
export default {
  components: { UploadImage, Dialog, Editor, Toolbar },

  data() {
    return {
      previewId: null,
      urlCode: '',
      showPreviewDialog: false,
      editor: null,
      form: new Content(),
      toolbarConfig: {
        excludeKeys: [
          'insertTable',
          'fullScreen',
          'code',
          'codeBlock',
        ],
        insertKeys: {
          index: 1,
          keys: 'BrMenu',
        },
      },
      editorConfig: {
        placeholder: 'Type here...',
        MENU_CONF: {
        },
        hoverbarKeys: {
          'image': {
            // 清空 image 元素的 hoverbar
            menuKeys: ["imageWidth24", "imageWidth30", "imageWidth48", "imageWidth50", "imageWidth100", "editImage", "viewImageLink", "deleteImage"],
          },
        },
      },
      mode: 'default', // or 'simple'
      values: [],
      formDialogShow: false,
      information: {},
      cancelTxt: "",
      disabledStatus: false,
      categoryList: [
        { id: 1, name: '市场内容' },
        { id: 2, name: 'Campaign page' },
      ],
      typeList: [],
      rules: {
        title: [
          { required: true, message: "请输入内容标题", trigger: ["blur"] },
        ],
        type: [
          { required: true, message: "请选择内容分类", trigger: ["blur"] },
        ],
        category: [
          { required: true, message: "请选择内容类别", trigger: ["blur"] },
        ],
        introduction: [
          { required: true, message: "请输入内容简介", trigger: ["blur"] },
        ],
        content: [
          {
            required: true, validator: (rule, value, callback) => {
              if (value === '<p><br></p>') {
                callback(new Error('请编辑内容'));
              } else {
                callback();
              }
            }, trigger: ["blur"],
          },
        ],
        coverImage: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const array = [];
              for (const key in value) {
                array.push(value[key]);
              }
              if (array.length !== 4 || array.some(item => !item)) {
                callback(new Error("请上传图片"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
      },
    };
  },
  watch: {
    "form.content": {
      handler() {
        const reg = /^<p><br><\/p>$/g;
        if (!reg.test(this.form.content)) {
          console.log('不是以这些开头');
          this.form.content = this.form.content.replace('<p><br></p>', '');
        }
      },
    },
  },
  async created() {
    // 修改 uploadImage 菜单配置
    const that = this;
    this.editorConfig = {
      ...this.editorConfig,
      MENU_CONF: {
        uploadImage: {
          async customUpload(file, insertFn) {
            that.$Api.uploadFile.uploadImage(file, 'static/image/dev/ua_content/detail/').then(data => {
              data && insertFn(data);
            });
          },
        },
        uploadVideo: {
          async customUpload(file, insertFn) {
            that.$Api.uploadFile.uploadVideo(file, '/static/video/dev/ua_content/detail/').then(data => {
              if (data && data.url) {
                insertFn(data.url);
              }
            });
          },
        },
      },
    };
    await this.fetchTypeList();
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      this.form.id = query.id;
      this.cancelTxt = "编辑";
      this.fetchMarketContent("edit");
    } else if (query.copyid) {
      this.form.id = query.copyid;
      this.cancelTxt = "复制";
      this.fetchMarketContent("copy");
    } else {
      this.cancelTxt = "新增";
    }
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  methods: {
    preview() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const object = { ...this.form };
          if (this.previewId) {
            object['id'] = this.previewId;
          } else {
            delete object['id'];
          }
          this.$Api.content.previewAdd(object).then(res => {
            this.previewId = res.id || '';
            this.urlCode = res.urlCode || '';
            this.showPreviewDialog = true;
          });
        }
      });
    },
    submit() {
      this.$refs.form.validate().then(res => {
        if (res) {
          this.formDialogShow = true;
          this.information = {
            operation: "submit",
            icon: "warn",
            subTitle: "是否确认保存编辑的内容？",
          };
        }
      });
    },
    // 获取内容分类下拉框
    fetchTypeList() {
      this.$Api.content.fetchTypeList().then(res => {
        if (res && res.length) {
          this.typeList = res;
        }
      });
    },
    // 初始化编辑器
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      console.log(this.editor, 'this.editor');
    },
    onBlur(e) {
      this.$refs.form.validateField("content");
    },
    handleCheckReg(val) {
      this.$refs.form.validateField("coverImage");
    },
    // 获取详情
    async fetchMarketContent(type) {
      const _this = this;
      await this.$Api.content.fetchMarketContent(this.form.id).then(res => {
        const reg = /^<p><br><\/p>.*/g;
        if (reg.test(res.content)) {
          res.content = res.content.replace('<p><br></p>', '');
          _this.form = Object.assign(_this.form, res);
        } else {
          _this.form = Object.assign(_this.form, res);
        }
        // 开放编辑状态
        // if (this.form.status === 0 && type === "edit") this.disabledStatus = true;
        if (type === "copy") delete this.form.id;
      });
    },

    // 新增市场内容
    addContent() {
      delete this.form.id;
      this.$Api.content.addMarketContent(this.form).then(() => {
        this.$message.success("保存成功");
        this.$router.go(-1);
      }).catch(err => {
        this.$message.error(err.errorMessage || '保存失败');
        this.$router.go(-1);
      });
    },
    // 更新接口
    updateContent() {
      this.$Api.content.updateMarketContent(this.form).then(() => {
        this.$message.success("编辑成功");
        this.$router.go(-1);
      }).catch(err => {
        this.$message.error(err.errorMessage || '保存失败');
        this.$router.go(-1);
      });
    },
    // 取消
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        if (['新增', '复制'].includes(this.cancelTxt)) {
          this.addContent();
        } else {
          this.updateContent();
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content-edit {
  .btns {
    align-items: center;
    justify-content: center;
  }
  .marginTop {
    margin-top: 30px;
  }
  .editor-box {
    /deep/ .w-e-image-container {
      margin: unset !important;
    }
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .form-icon {
    margin-left: 10px;
    .el-icon-close {
      color: #9b9b9b;
      cursor: pointer;
      &:hover {
        color: #000000;
      }
    }
  }
  .form-add {
    margin-top: 24px;
    .el-button {
      border: 1px dashed #bbbbbb;
      i {
        color: #bbbbbb;
      }
      span {
        color: #bbbbbb;
      }
    }
  }
  .image-config {
    .el-form-item__label {
      float: none;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.hide-required {
      .el-form-item__label {
        &::before {
          display: none;
        }
      }
    }
  }
  .white-container-bottom {
    padding-bottom: 0;
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  /deep/.preview-wrapper {
    width: 538px;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      height: 400px;
      padding: 30px;
      box-sizing: border-box;
      .qr-wrap {
        text-align: center;
        .qr-code {
          width: 300px;
          height: 300px;
          margin-bottom: 20px;
        }
        p {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 23px;
          color: #494949;
        }
      }
    }
  }
  /deep/.w-e-textarea-video-container {
    max-width: 100%;
    video {
      width: 100%;
    }
  }
}
</style>
